<template>
    <div>
        <div class="container text-center mt-5">
            <h2>Menu Principal</h2>
            <p>Acesse os paineis de controle</p>
            <div class="containe col-12">
                <div class="col-12 divAction">
                    <router-link to="/TabelaFrota" class="btn btnAction">Tabela Frota</router-link>
                </div>
                <div class="col-12 divAction">
                    <router-link to="/MultiSql" class="btn btnAction">Multi Sql</router-link>
                </div>
                <div class="col-12 divAction">
                    <router-link to="/agendadorTarefas" class="btn btnAction">Agendador de Tarefas</router-link>
                </div>
                <div class="col-12 divAction">
                    <router-link to="/dicionario" class="btn btnAction">Dicionário de tradução</router-link>
                </div>
                <div class="col-12 divAction">
                    <router-link to="/monitoramento" class="btn btnAction">Monitoramento</router-link>
                </div>
                <!-- <div class="col-12 mt-5">
                    <button @click="testarLink" class="btn btn-outline-success">Testar Link</button>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        testarLink() {

            const url = 'https://www.youtube.com'

            var img = new Image();
            img.onload = function () {
                console.log(`O site ${url} está respondendo.`);
            };
            img.onerror = function () {
                console.error(`O site ${url} não está acessível.`);
            };
            img.src = url;
        }
    }
}
</script>
<style>
.divAction {
    margin: 10px;
    border-radius: 25px;
    color: #fff;
    background: linear-gradient(45deg, #2c2d8cab, #3417ac);
    box-shadow: 0px 2px 8px -3px #000;
    background-color: #000;
    height: 50px;
    transition: 0.7s;
    display: flex;
    justify-content: center;
    align-items: center;
}

.divAction:hover {
    height: 60px;
}

.btnAction {
    margin: 10px;
    border-radius: 25px;
    color: #fff;
}

.btnAction:hover {
    color: #fff;

}
</style>